export function facebookSdkIntegration(appId) {
  let scriptElement = document.createElement('script')
  scriptElement.innerHTML = `window.fbAsyncInit = function() {
    FB.init({
      appId      : ${appId},
      xfbml      : true,
      version    : 'v17.0',
      cookie     : true,
    });
    FB.AppEvents.logPageView();
  };

  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));`
  document.body.insertBefore(scriptElement, document.body.firstChild)
}
